import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup, Polygon, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Peta = () => {
  const { isDarkMode } = useDarkMode();

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  });

  const coverageMapMarkers = [
    { position: [5.5505, 95.3194], name: 'Banda Aceh', status: 'Tersedia Semua Paket' },
    { position: [5.3932, 95.3204], name: 'Aceh Besar', status: 'Tersedia Semua Paket' },
    { position: [5.8833, 95.3000], name: 'Sabang', status: 'Tersedia Fiber & Mobile' },
    { position: [3.5952, 98.6722], name: 'Medan', status: 'Tersedia Semua Paket' },
    { position: [2.9520, 99.0615], name: 'Pematangsiantar', status: 'Tersedia Fiber & Mobile' },
    { position: [-0.9471, 100.4172], name: 'Padang', status: 'Tersedia Semua Paket' },
    { position: [-0.2633, 100.3774], name: 'Bukittinggi', status: 'Tersedia Fiber & Mobile' },
    { position: [0.5070, 101.4478], name: 'Pekanbaru', status: 'Tersedia Semua Paket' },
    { position: [1.1093, 104.0304], name: 'Batam', status: 'Tersedia Semua Paket' },
    { position: [-2.9761, 104.7754], name: 'Palembang', status: 'Tersedia Semua Paket' },
    { position: [-5.4292, 105.2610], name: 'Bandar Lampung', status: 'Tersedia Semua Paket' },
    { position: [-6.2088, 106.8456], name: 'Jakarta', status: 'Tersedia Semua Paket' },
    { position: [-6.1745, 106.8227], name: 'Jakarta Utara', status: 'Tersedia Semua Paket' },
    { position: [-6.2297, 106.8467], name: 'Jakarta Selatan', status: 'Tersedia Semua Paket' },
    { position: [-6.9175, 107.6191], name: 'Bandung', status: 'Tersedia Semua Paket' },
    { position: [-6.5622, 106.7208], name: 'Bogor', status: 'Tersedia Semua Paket' },
    { position: [-6.7366, 108.5526], name: 'Cirebon', status: 'Tersedia Fiber & Mobile' },
    { position: [-7.0051, 110.4381], name: 'Yogyakarta', status: 'Tersedia Semua Paket' },
    { position: [-6.9932, 110.4203], name: 'Semarang', status: 'Tersedia Semua Paket' },
    { position: [-7.5663, 110.8281], name: 'Surakarta', status: 'Tersedia Fiber & Mobile' },
    { position: [-7.2575, 112.7521], name: 'Surabaya', status: 'Tersedia Semua Paket' },
    { position: [-7.9797, 112.6304], name: 'Malang', status: 'Tersedia Semua Paket' },
    { position: [-8.2197, 113.9087], name: 'Banyuwangi', status: 'Tersedia Fiber & Mobile' },
    { position: [-8.6705, 115.2126], name: 'Denpasar', status: 'Tersedia Semua Paket' },
    { position: [-8.3405, 115.0920], name: 'Ubud', status: 'Tersedia Fiber & Mobile' },
    { position: [-8.5833, 116.1167], name: 'Mataram', status: 'Tersedia Fiber & Mobile' },
    { position: [-10.1772, 123.6070], name: 'Kupang', status: 'Tersedia Mobile' },
    { position: [-0.0263, 109.3425], name: 'Pontianak', status: 'Tersedia Semua Paket' },
    { position: [-2.2090, 113.9213], name: 'Palangka Raya', status: 'Tersedia Mobile' },
    { position: [-3.3194, 114.5906], name: 'Banjarmasin', status: 'Tersedia Semua Paket' },
    { position: [1.2753, 116.8267], name: 'Samarinda', status: 'Tersedia Fiber & Mobile' },
    { position: [-0.5022, 117.1537], name: 'Balikpapan', status: 'Tersedia Semua Paket' },
    { position: [1.4748, 124.8421], name: 'Manado', status: 'Tersedia Semua Paket' },
    { position: [-0.8999, 119.8707], name: 'Palu', status: 'Tersedia Mobile' },
    { position: [-5.1477, 119.4327], name: 'Makassar', status: 'Tersedia Semua Paket' },
    { position: [-4.1351, 122.1741], name: 'Kendari', status: 'Tersedia Mobile' },
    { position: [-3.6954, 128.1814], name: 'Ambon', status: 'Tersedia Mobile' },
    { position: [-0.8650, 134.0687], name: 'Sorong', status: 'Tersedia Mobile' },
    { position: [-2.5489, 140.7197], name: 'Jayapura', status: 'Tersedia Mobile' },
  ];

  const coverageAreas = [
    { name: 'Banda Aceh', coords: [[5.57,95.30],[5.56,95.34],[5.53,95.33],[5.52,95.31]], color: '#3B82F6', status: 'Full Coverage' },
    { name: 'Aceh Besar', coords: [[5.40,95.28],[5.42,95.35],[5.37,95.36],[5.36,95.30]], color: '#10B981', status: 'Full Coverage' },
    { name: 'Sabang', coords: [[5.90,95.28],[5.91,95.32],[5.86,95.33],[5.85,95.29]], color: '#8B5CF6', status: 'Partial Coverage' },
    { name: 'Jakarta Pusat', coords: [[-6.15,106.80],[-6.15,106.87],[-6.23,106.87],[-6.23,106.80]], color: '#EF4444', status: 'Premium Coverage' },
    { name: 'Jakarta Selatan', coords: [[-6.23,106.78],[-6.23,106.87],[-6.37,106.87],[-6.37,106.78]], color: '#F59E0B', status: 'Premium Coverage' },
    { name: 'Bandung', coords: [[-6.87,107.57],[-6.87,107.67],[-6.95,107.67],[-6.95,107.57]], color: '#06B6D4', status: 'Full Coverage' },
    { name: 'Surabaya', coords: [[-7.21,112.68],[-7.21,112.80],[-7.32,112.80],[-7.32,112.68]], color: '#84CC16', status: 'Premium Coverage' },
    { name: 'Medan', coords: [[3.55,98.62],[3.55,98.72],[3.63,98.72],[3.63,98.62]], color: '#F97316', status: 'Full Coverage' },
    { name: 'Yogyakarta', coords: [[-7.94,110.36],[-7.94,110.50],[-8.00,110.50],[-8.00,110.36]], color: '#EC4899', status: 'Full Coverage' },
    { name: 'Semarang', coords: [[-6.96,110.37],[-6.96,110.47],[-7.03,110.47],[-7.03,110.37]], color: '#8B5CF6', status: 'Full Coverage' },
    { name: 'Denpasar', coords: [[-8.63,115.17],[-8.63,115.25],[-8.72,115.25],[-8.72,115.17]], color: '#06B6D4', status: 'Full Coverage' },
    { name: 'Makassar', coords: [[-5.11,119.38],[-5.11,119.48],[-5.20,119.48],[-5.20,119.38]], color: '#10B981', status: 'Full Coverage' },
    { name: 'Palembang', coords: [[-2.94,104.73],[-2.94,104.82],[-3.01,104.82],[-3.01,104.73]], color: '#F59E0B', status: 'Full Coverage' },
    { name: 'Manado', coords: [[1.44,124.80],[1.44,124.88],[1.50,124.88],[1.50,124.80]], color: '#8B5CF6', status: 'Full Coverage' },
    { name: 'Balikpapan', coords: [[-0.46,117.11],[-0.46,117.19],[-0.54,117.19],[-0.54,117.11]], color: '#06B6D4', status: 'Partial Coverage' },
    { name: 'Pontianak', coords: [[0.01,109.30],[0.01,109.38],[-0.06,109.38],[-0.06,109.30]], color: '#84CC16', status: 'Full Coverage' },
    { name: 'Padang', coords: [[-0.92,100.37],[-0.92,100.46],[-0.99,100.46],[-0.99,100.37]], color: '#F97316', status: 'Full Coverage' },
    { name: 'Pekanbaru', coords: [[0.47,101.40],[0.47,101.49],[0.54,101.49],[0.54,101.40]], color: '#EF4444', status: 'Full Coverage' },
    { name: 'Bandar Lampung', coords: [[-5.40,105.23],[-5.40,105.30],[-5.46,105.30],[-5.46,105.23]], color: '#EC4899', status: 'Full Coverage' },
    { name: 'Batam', coords: [[1.08,103.99],[1.08,104.07],[1.14,104.07],[1.14,103.99]], color: '#3B82F6', status: 'Premium Coverage' },
  ];

  return (
    <div
      className="rounded-2xl shadow-sm overflow-hidden"
      style={{
        backgroundColor: isDarkMode ? '#111827' : '#f3f4f6',
        height: '500px',
      }}
    >
      <MapContainer
        center={[-2.5489, 118.0149]}
        zoom={5}
        style={{ height: '100%', width: '100%', borderRadius: '1rem' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {coverageMapMarkers.map((marker, index) => (
          <Marker key={index} position={marker.position}>
            <Popup>
              <div className="font-semibold text-gray-800">{marker.name}</div>
              <div className="text-sm text-gray-600">{marker.status}</div>
            </Popup>
          </Marker>
        ))}
        {coverageAreas.map((area, index) => (
          <Polygon key={index} positions={area.coords} pathOptions={{ color: area.color, weight: 2, fillOpacity: 0.15, opacity: 0.8 }}>
            <Tooltip sticky>
              <div className="font-semibold">{area.name}</div>
              <div className="text-xs">{area.status}</div>
            </Tooltip>
          </Polygon>
        ))}
      </MapContainer>
    </div>
  );
};

export default Peta;
